// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"ContactDetailsPage_bi-chevron-down__3Er1e","content":"ContactDetailsPage_content__1Cdn7","title":"ContactDetailsPage_title__3UEQW"};